<template>
<v-app id="inspire">

    <!--v-main>
        <component :is="layout">
            <router-view :layout.sync="layout" />
        </component>
    </v-main-->
<router-view/>
</v-app>
</template>

<script>
import ApiList from './components/ApiList'

export default {
    components: {

    },
    mixins: [ApiList],
    // data: () => ({
    //     drawer: null,
    //     viewSearch: false,
    //     searchString: '',
    //     loginStatus: false

    //  }),
    data() {
        return {
//            layout: `div`
        }
    },
    mounted() {
        this.loadData()
    },
    watch: {
        loginStatus() {

        }
    },
    methods: {
        loadData() {
            this.loginStatus = localStorage.getItem("loginStatus");
            // alert(this.loginStatus)
        },
        expandSerach() {
            if (this.viewSearch == true) {
                this.viewSearch = false
            } else {
                this.viewSearch = true
            }
            // alert(this.viewSearch)
        },
    },

}
</script>
